import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'
import UtilsService from './utils.service'
import FrontPageEnum from '../enumerators/front-page.enum'

export default class HomeService {
	constructor() {
		HomeService.strateOrganiserSlider().then()
		HomeService.dynamicStrateOrganiserCursor()
		HomeService.strateOrganiserCategoriesClickActions()
		HomeService.strateOrganiserToggleActiveClass()
		HomeService.strateAgendaSlider().then()

		if (window.matchMedia('(min-width: 1001px)').matches) {
			if (!$('body').hasClass('eco-mode-active')) {
				HomeService.initInstagramWall()
			}
		}
		HomeService.removeHeaderAnimatedClass()
		if (
			!$('body').hasClass('eco-mode-active') &&
			window.matchMedia('(min-width: 1001px)').matches
		) {
			UtilsService.scrollRevealWithIntersectObserver()
		}
	}

	static async strateOrganiserSlider() {
		const options = {
			slidesPerView: 1,
			spaceBetween: 15,
			speed: 1500,
			breakpoints: {
				650: {
					slidesPerView: 2,
					spaceBetween: 40,
				},
			},
		}

		if (typeof IRISCollectionCustomer.strateOrganiserCategories === 'object') {
			for (const key of Object.keys(IRISCollectionCustomer.strateOrganiserCategories)) {
				const selector = `[data-slider="strate-organiser-${key}"]`

				UtilsService.swiperWrapper(selector, 'div')

				await Swiper.create(selector, options)
			}
		}
	}

	static dynamicStrateOrganiserCursor() {
		const $strateOrganiser = $('.strate__organiser')

		if ($strateOrganiser.length) {
			const categories = $strateOrganiser.find('[data-element="strate-organiser-selector"]')

			$(categories).each(function () {
				const cursor = $(this).find('[data-element="strate-organiser-cursor"]')
				const category = $(this).find('[data-element="strate-organiser-category"]')

				$(category).hover(function () {
					const category_top = $(this).position().top + 12
					$(cursor).css('top', category_top)
				})

				$(category).on('click', function () {
					const category_top = $(this).position().top + 12
					$(cursor).css('top', category_top)
				})
			})
		}
	}

	static strateOrganiserCategoriesClickActions() {
		const $strateOrganiser = $('.strate__organiser')

		if ($strateOrganiser.length) {
			const categories = '[data-element="strate-organiser-selector"]'

			$(categories).each(function () {
				const category = $(this).find('[data-element="strate-organiser-category"]')

				$(this)
					.find('[data-element="strate-organiser-category"]')
					.first()
					.addClass('active')

				$(category).on('click', function (e) {
					e.preventDefault()

					if ($(this).hasClass('active')) {
						if ($(this).attr('data-target').length > 0) {
							location.href = $(this).attr('data-target')
						}
					}

					$(category).removeClass('active')
					$(this).addClass('active')
				})
			})
		}
	}

	static strateOrganiserDynamicLayoutSlider() {
		const $strateOrganiser = $('.strate__organiser')
		if ($strateOrganiser.length) {
			const items = $strateOrganiser.find('[data-element="strate-organiser-item"]')
			const categories = $strateOrganiser.find('[data-element="strate-organiser-selector"]')
			const init_item_category = $strateOrganiser
				.find('[data-element="strate-organiser-category"]')
				.first()
				.attr('data-cetegory-slug')
			let items_count = $strateOrganiser.find(
				`[data-item-category-slug="${init_item_category}"]`,
			).length

			$(categories).each(function () {
				const category = $(this).find('[data-element="strate-organiser-category"]')

				//Init display items
				$(items).each(function () {
					const item_category = $(this).attr('data-item-category-slug')
					if (item_category !== init_item_category) {
						$(this).hide()
					}
				})

				//On click display items
				$(category).on('click', function () {
					const category_selected = $(this).attr('data-category-slug')
					items_count = $strateOrganiser.find(
						`[data-item-category-slug="${$(this).attr('data-slug')}"]`,
					).length

					$(items).each(function () {
						const item_category = $(this).attr('data-item-category-slug')
						if (item_category !== category_selected) {
							$(this).hide()
						} else {
							$(this).show()
						}
					})
				})
			})
		}
	}

	static strateOrganiserToggleActiveClass() {
		const $strateOrganiserItems = $('[data-element="strate-organiser-items"]')
		const $strateOrganiserCategories = $('[data-element="strate-organiser-category"]')

		$strateOrganiserItems.first().addClass('active')

		$strateOrganiserCategories.on('click', function () {
			const activeCategoryId = $(this).data('category-slug')

			$strateOrganiserCategories.removeClass('active')
			$(this).addClass('active')

			$strateOrganiserItems.removeClass('active')
			$(
				`[data-element="strate-organiser-items"][data-slider-id="${activeCategoryId}"]`,
			).addClass('active')
		})
	}

	static async strateAgendaSlider() {
		const selector = '[data-slider="strate-agenda-items"]'
		const options = {
			slidesPerView: 1,
			spaceBetween: 15,
			speed: 1500,
			autoplay: {
				delay: 3000,
			},
			breakpoints: {
				650: {
					slidesPerView: 2,
					spaceBetween: 40,
				},
			},
		}

		UtilsService.swiperWrapper(selector, 'div')

		await Swiper.create(selector, options)
	}

	static async initInstagramWall() {
		const $selector = $(FrontPageEnum.STRATE_SOCIAL_WALL)

		if ($selector.length > 0 && !$selector.is(':hidden')) {
			const apiFetch = await import('@wordpress/api-fetch')

			apiFetch({
				path: IRISCollectionCustomer.irisSsoInstagramPath,
				method: 'POST',
				data: {limit: 4},
			})
				.then((result) => {
					$selector.html(result.render)
					import(
						'@iris.interactive/handcook/public/scripts/components/lazyload/lazyload.component' /* webpackChunkName: "scripts/hc_lazyload" */
						).then(({HcLazyload}) => {
						HcLazyload.update()
					})
				})
				.catch(() => {
					console.log(IRISCollectionCustomer.irisSsoInstagramError)
				})
		}
	}

	static removeHeaderAnimatedClass() {
		const headerAnimated = $('body.header-animated')
		const body = $('body')

		if (headerAnimated.length) {
			setTimeout(() => {
				body.removeClass('header-animated')
			}, 2000)
		}
	}
}
